/* ----------------------------------------------------------------
Import modules
---------------------------------------------------------------- */

import VideoController from '../classes/video-embed';
import ModalController from '@meteora-digital/modal';

/* ----------------------------------------------------------------
Video Block
---------------------------------------------------------------- */

// Select all the video blocks
[...document.querySelectorAll('[data-video-modal]')].forEach(block => {
  const url = block.getAttribute('data-video-modal');
  // Create a video embed
  const Modal = new ModalController();
  // Create a new VideoEmbed
  const Video = new VideoController(url);
  // A div to hold the video
  const container = document.createElement('div');
  const holder = document.createElement('div');
  container.classList.add('responsive-video');
  holder.classList.add('responsive-video__holder');
  container.appendChild(holder);
  holder.appendChild(Video.iframe);
  Modal.append(container);

  // When we click on the block, append the Video.iframe to the block
  block.addEventListener('click', e => {
    e.preventDefault();
    Modal.open();
  });
});